import React from 'react'
import tw from 'twin.macro'
import {ModalButton} from 'baseui/modal'
import {ButtonProps} from 'baseui/button'

export const ModalButtonWrapper: React.FC<ButtonProps> = (props) => {
  const {children, type, ...params} = props
  return (
    <ModalButton
      overrides={{
        BaseButton: {
          style: () => ({
            ...tw`font-secondary font-medium`,
            width: '100%',
            backgroundColor: type === 'submit' ? '#36FAD7' : '#36FAD7',
            fontSize: '14px',
            lineHeight: '18px',
            paddingTop: '11px',
            paddingBottom: '11px',
            color: '#000000',
            ':hover': {
              backgroundColor: '#36FAD7',
            },
          }),
        },
      }}
      {...params}
    >
      {children}
    </ModalButton>
  )
}
